import { usePage } from '@inertiajs/react';
import type { HackerOnboardingShow } from '@/types';
import { AdditionalInfoForm } from './components/AdditionalInfoForm';
import { AnthropicCreditsForm } from './components/AnthropicCreditsForm';
import { CompleteProfileForm } from './components/CompleteProfileForm';
import { DiscordConnectStep } from './components/DiscordConnectStep';
import { OnboardingComplete } from './components/OnboardingComplete';
import { SocialProfilesForm } from './components/SocialProfilesForm';
import { WelcomeAndTerms } from './components/WelcomeAndTerms';

// app/(hack)/hacker/(protected)/**/onboarding/page.tsx — the four twins as one page
// (PORTING.md G5). Over there the dispatcher was the server component returning a
// different child; here the server picks the step and this renders it.
export default function Show({
  step,
  edition,
  hackerFullName,
  hackerGithub,
  countryOptions,
  defaultCountry,
  needsLinkedin,
  needsShirtSize,
  defaultLinkedin,
  defaultX,
  discordOauthUrl,
  discordError,
}: HackerOnboardingShow) {
  const { auth } = usePage().props;

  switch (step) {
    case 'terms':
      return (
        <WelcomeAndTerms
          edition={edition}
          hackerGithub={hackerGithub}
          userName={auth.user?.name ?? ''}
          userEmail={auth.user?.email ?? ''}
          userImage={auth.user?.image ?? null}
        />
      );
    case 'additional_info':
      return (
        <AdditionalInfoForm
          edition={edition}
          countryOptions={countryOptions}
          defaultCountry={defaultCountry}
        />
      );
    case 'complete_profile':
      return (
        <CompleteProfileForm
          edition={edition}
          needsLinkedin={needsLinkedin}
          needsShirtSize={needsShirtSize}
          defaultLinkedin={defaultLinkedin}
        />
      );
    case 'social_profiles':
      return (
        <SocialProfilesForm
          edition={edition}
          defaultLinkedin={defaultLinkedin}
          defaultX={defaultX}
        />
      );
    case 'anthropic_credits':
      return <AnthropicCreditsForm edition={edition} />;
    case 'discord':
      return (
        <DiscordConnectStep
          edition={edition}
          discordOauthUrl={discordOauthUrl ?? ''}
          discordError={discordError}
        />
      );
    default:
      return (
        <OnboardingComplete edition={edition} hackerFullName={hackerFullName} />
      );
  }
}
